<a
  *ngIf="isExternalLink"
  [class.w-full]="isMobile"
  [href]="url"
  app-vtmn-play-button
  [variant]="variant"
  target="_blank"
  [size]="VtmnPlayButtonSize.MEDIUM"
  [shape]="shape"
  rel="noopener noreferrer"
>
  {{ text }}
</a>

<a
  class="picture-and-text__button"
  [class.w-full]="isMobile"
  *ngIf="!isExternalLink"
  [routerLink]="url | localize"
  app-vtmn-play-button
  [variant]="variant"
  [size]="VtmnPlayButtonSize.MEDIUM"
  [shape]="shape"
>
  {{ text }}
</a>
